<template>
  <v-container fluid class="salesSettings">
    <v-layout>
      <v-btn
        :disabled="getDataLoading"
        color="primary"
        @click="handleDepartment(false)"
        >{{ $t('addDepartment') }}
      </v-btn>
      <template v-if="isMod">
        <v-btn color="primary" @click="cancelEdit">{{ $t('cancel') }} </v-btn>
        <v-btn
          :loading="saveLoading"
          color="primary"
          @click="submit"
          >{{ $t('save') }}
        </v-btn>
      </template>
      <v-btn
        v-else
        color="primary"
        :disabled="!departments.length || getDataLoading"
        @click="handleDepartment(true)"
        >{{ $t('editDepartment') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-flex md2 xs4>
        <v-select
          style="paddingTop: 0"
          v-model="departmentFilter"
          :items="departments"
          :label="$t('departmentFilter')"
          item-text="name"
          item-value="name"
          clearable
        ></v-select>
      </v-flex>
    </v-layout>

    <v-form ref="form">
      <v-data-table :headers="headers" :items="tableData">
        <template v-slot:items="props">
          <td class="text-xs-left">
            <template v-if="!isMod">{{ props.item.name }}</template>
            <v-text-field
              v-else
              v-model="props.item.name"
              clearable
              :rules="[fieldIsRequired()]"
              required
            />
          </td>
          <td class="text-xs-left">
            <template v-if="!isMod">{{ props.item.leaderName }}</template>
            <v-text-field
              v-else
              v-model.trim="props.item.leaderName"
              clearable
              :rules="[fieldIsRequired()]"
              required
            />
          </td>
          <td class="text-xs-left">
            <template v-if="!isMod">
              <v-chip v-for="tag in props.item.managers || []" :key="tag">
                {{ tag }}
              </v-chip>
            </template>
            <v-combobox
              v-else
              v-model="props.item.managers"
              :label="$t('enterToAddManager')"
              required
              hide-selected
              multiple
              persistent-hint
              small-chips
            >
            </v-combobox>
          </td>
          <td class="text-xs-left" v-if="isMod">
            <v-layout justify-center>
            <v-btn color="primary" flat icon @click="deleteDepartment(props.index)">
              <v-icon color="lighten-2">delete</v-icon>
            </v-btn></v-layout>
          </td>
        </template>
      </v-data-table>
    </v-form>
  </v-container>
</template>

<script>
import { checkRules, cloneDeep } from '@/utils/tools'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'salesSettings',
  mixins: [checkRules],
  data () {
    return {
      isMod: false,
      cacheData: [],
      departmentFilter: '',
      getDataLoading: false,
      saveLoading: false
    }
  },
  computed: {
    headers () {
      const headers = [
        { text: this.$t('name'), value: 'name', sortable: false },
        { text: this.$t('leader'), value: 'leaderName', sortable: false },
        { text: this.$t('manager'), value: 'managers', width: '60%', sortable: false }
      ]
      if (this.isMod) {
        headers.push({
          text: this.$t('actions'),
          value: 'actions',
          width: '120px',
          align: 'center',
          sortable: false
        })
      }
      return headers
    },
    tableData () {
      if (this.isMod) return this.cacheData
      return this.departments.filter(item => !this.departmentFilter || item.name.includes(this.departmentFilter))
    },
    ...mapGetters(['departments'])
  },
  created () {},
  methods: {
    ...mapActions(['updateSysAdminDepartmentList']),
    async submit () {
      const valid = this.$refs.form.validate()
      if (!valid) return
      this.saveLoading = true
      try {
        await this.updateSysAdminDepartmentList({ departments: this.cacheData })
        this.saveLoading = false
        this.isMod = false
        this.cacheData = []
      } catch (err) {
        console.log(err)
        this.saveLoading = false
      }
    },
    cancelEdit () {
      this.isMod = false
    },
    handleDepartment (isMod = false) {
      if (!this.isMod) this.cacheData = this.copyData()
      if (!isMod) this.cacheData.unshift(this.initData())
      this.isMod = true
      this.departmentFilter = ''
      this.$refs.form.resetValidation()
    },
    deleteDepartment (index) {
      if (!this.isMod) return
      this.cacheData.splice(index, 1)
    },
    copyData () {
      return cloneDeep(this.departments)
    },
    initData () {
      return {
        name: '',
        managers: []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SalesSettings.vue